import { ConfigStore, STR_ERRORS, storeToken, execFunction } from "../common";
import { ConnectionsFactory } from "./ConnectionsFactory";
import { ConnectWithToken } from "./ConnectionWithToken";
import { disposer as handler } from "@draftkings/sportsbook-common-utils";
let disposer = handler;
export function init(config) {
    ConfigStore.config = Object.assign(Object.assign({}, ConfigStore.config), config);
    if (Object.keys(ConfigStore.config.urls).length === 0) {
        throw new Error(STR_ERRORS.NoConnectionUrls);
    }
    disposer = ConfigStore.config.onTokenRenew(token => storeToken(token));
    const connectionNames = Object.keys(ConfigStore.config.urls);
    if (!ConfigStore.config.connections.jwt) {
        ConfigStore.config.requestToken().then(token => {
            storeToken(token);
            connectionNames.forEach((connectionName) => execFunction(ConnectWithToken[connectionName], token));
        }).catch(undefined);
    }
    connectionNames.forEach(x => ConnectionsFactory[x](ConfigStore.config.urls[x]));
}
window.addEventListener("beforeunload", () => {
    disposer();
});
//# sourceMappingURL=App.js.map